import { defineStore } from "pinia";
import type { QuotaViolation } from "@/services/billingApi";

/**
 * licenseQuotaStore owns the "your license is full, please upgrade" dialog
 * that pops up whenever a backend write returns a 402 with a
 * license_*_quota_exceeded code. The dialog itself is mounted once in
 * App.vue; call sites only need to push/pop violations via showQuota/close.
 */
export const useLicenseQuotaStore = defineStore("licenseQuota", {
  state: (): {
    visible: boolean;
    quota: QuotaViolation | null;
  } => ({
    visible: false,
    quota: null,
  }),

  actions: {
    showQuota(quota: QuotaViolation) {
      this.quota = quota;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
});
